<template>
  <div class="api__bg rounded d-inline-block">
    <img :src="`${pre}top-shadow.png`" class="top-shadow" />
    <img :src="`${pre}top-shadow-2.png`" class="top-shadow-mob" />
    <div style="display: flex; justify-content: center">
      <div>
        <div class="buy-now-btn__wrapper">
          <button
            class="carousel__button"
            data-action="csWidgetOpen"
            :data-id="props.active == 1 ? 2 : props.active == 2 ? 1 : 3"
            tabindex="0"
          >
            <img
              :src="`${pre}buy-now-top.png`"
              class="buy-btn-top"
              style="width: 120px"
            />
          </button>
        </div>
        <div class="buy-now__arrow"></div>
      </div>
    </div>
    <div class="tab-content">
      <div
        v-for="(item, index_2) in dataModel"
        :key="item"
        class="tab-pane"
        :class="index_2 == props.active ? 'active' : ''"
        :id="'retailer-' + index_2"
      >
        <div
          v-if="props.active == 2"
          :class="
            index_2 == 2
              ? 'api-2 p-2 d-flex justify-content-center align-items-center'
              : 'api p-2 d-flex justify-content-center align-items-center'
          "
        >
          <div
            v-for="item in dataModel[1].retailers"
            :key="item"
            class="api__retailer"
          >
            <div>
              <a :href="item.url" class="api__a d-block" target="_blank">
                <div
                  class="api__img-wrapper rounded-top p-1 temp__center bg-white"
                >
                  <img :src="item.logo" class="api__img--logo d-block w-100" />
                </div>
                <div
                  class="api__price p-1 text-white text-center rounded-bottom"
                  :style="{ 'background-color': '#CD0006' }"
                >
                  £{{ item.price }}
                </div>
              </a>
            </div>
          </div>
        </div>
        <div
          v-if="props.active == 1"
          :class="
            index_2 == 2
              ? 'api-2 p-2 d-flex justify-content-center align-items-center'
              : 'api p-2 d-flex justify-content-center align-items-center'
          "
        >
          <div
            v-for="item in dataModel[2].retailers"
            :key="item"
            class="api__retailer"
          >
            <div>
              <a :href="item.url" class="api__a d-block" target="_blank">
                <div
                  class="api__img-wrapper rounded-top p-1 temp__center bg-white"
                >
                  <img :src="item.logo" class="api__img--logo d-block w-100" />
                </div>
                <div
                  class="api__price p-1 text-white text-center rounded-bottom"
                  :style="{ 'background-color': '#CD0006' }"
                >
                  £{{ item.price }}
                </div>
              </a>
            </div>
          </div>
        </div>
        <div
          v-if="props.active > 2"
          :class="
            index_2 == 3
              ? 'api-3 p-2 d-flex justify-content-center align-items-center'
              : 'api p-2 d-flex justify-content-center align-items-center'
          "
        >
          <div
            v-for="item in dataModel[props.active].retailers"
            :key="item"
            class="api__retailer"
          >
            <div>
              <a :href="item.url" class="api__a d-block" target="_blank">
                <div
                  class="api__img-wrapper rounded-top p-1 temp__center bg-white"
                >
                  <img :src="item.logo" class="api__img--logo d-block w-100" />
                </div>
                <div
                  class="api__price text-white text-center rounded-bottom"
                  :style="{ 'background-color': '#CD0006' }"
                >
                  £{{ item.price }}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: this.newIndex,
    };
  },
};
</script>

<script setup>
import dataModel from "../js/model.js";
const props = defineProps({
  //index of active product
  active: {
    type: Number,
    default: 1,
  }, 
  pre: {
    type: String,
    default: "1",
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.buy-btn-1 {
  @media screen and (max-width: 640px) {
    display: none;
  }
}
.api,
.api-2,
.api-3 {
  margin-top: 20px;
}
.top-shadow {
  position: absolute;
  left: 0;
  z-index: -10;
  width: 100%;
  height: 150px;
}
.top-shadow-mob {
  display: none;
}

div.inline-nav__text--1 {
  margin-top: 10px !important;
  margin-left: 70px !important;
  font-size: 12px !important;
  font-weight: 900 !important;
}
.inline-nav__text--2 {
  margin-top: 10px !important;
}
.inline-nav__text--3 {
  margin-top: 17px !important;
}
.nav-tabs .nav-link {
  margin-left: -80px;
  min-height: 65px;
  border: 0.5px solid #a27726;
  background-color: #ffffff;
  color: #a27726;
  padding-top: 8px !important;
  border-radius: 75px 75px;
}

.nav-link.active {
  color: #ffffff !important;
  background-color: #cd0006 !important;
  border-color: #a27726 !important;
  font-weight: 900 !important;
  margin-left: -50px;
}
.rounded-top {
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}
.rounded-bottom {
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}
.api__price {
  padding: 0.25rem;
}
.buy-now-btn__wrapper {
  margin-top: -49.5px;
}
.pe--none {
  pointer-events: none;
}
.api__bg {
  z-index: 10;
  position: relative;
  width: 100%;
  background-repeat: repeat;
  background-size: 100% auto;
  // margin-top: -11px;

  @media screen and (max-width: 640px) {
    position: fixed;
    bottom: 0px !important;
    left: 0px !important;
    margin-right: 10px;
    width: 100% !important;
    z-index: 150 !important;
    .api {
      justify-content: start !important;

      min-width: 820px;
      min-height: 100px;
    }
    .api-2 {
      justify-content: start !important;
      min-width: 550px;
      min-height: 100px;
    }
    .api-3 {
      justify-content: start !important;
      min-width: 640px;
      min-height: 100px;
    }
    .buy-btn-top {
      margin-top: -65px;
    }
    .nav {
      top: -35vh;
      z-index: 100;
    }
    .tab-content {
      margin-top: -60px;
    }
    .top-shadow {
      display: none;
    }
    .top-shadow-mob {
      display: block !important;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: -10;
      width: 100%;
      height: 110px;
    }
  }
}
@media screen and (max-width: 400px) {
  .tab-content {
    margin-top: -40px;
  }
}
@media screen and (max-width: 370px) {
  .api__price {
    padding: 0px !important;
  }
  .api__a {
    max-width: 57px !important;
  }
  .api__bg .api-3 {
    min-width: 475px !important;
  }
  .api__bg .api-2 {
    min-width: 410px !important;
  }
  .api__bg .api {
    min-width: 610px !important;
  }
}
@media screen and (max-width: 640px) {
  .gold-border-retailers {
    display: none !important;
  }
  .buy-btn-top {
    display: none;
  }
}

.api-2 {
  min-width: 790px;
}
.pseudo-active:after {
  opacity: 1;
}
.api[data-id="1"] {
  min-width: 816px !important;
}
.nav {
  flex-wrap: nowrap;
  flex-direction: column;
  top: -42vh;
  left: 0;
  position: absolute;
}
.nav-tabs {
  overflow: auto;
}
.nav-tabs li {
  min-width: 160px;
}
.carousel__bg {
  height: 100%;
  width: 100%;
}
.nav-link {
  font-size: 12px;
}
ul {
  list-style: none;
}
.tab-content {
  overflow: auto;
}
.api__retailer {
  &:not(:last-child) {
    margin-right: 10px;
  }
  &:last-child:after {
    content: "";
    height: 100%;
    right: -10px;
    top: 0;
    background: none;
    width: 20px;
  }
}
.api__img-wrapper {
  border: 1px solid #f0f0f0;
}
.api__img-wrapper img {
  height: 85%;
}
.api__a {
  max-width: 80px;
  color: #333333;
  text-decoration: none;
}
.api__price {
  font-size: 15px;
  font-weight: 100;
  letter-spacing: 0.5px;
}
.dragging {
  pointer-events: none;
}
.nav-link {
  line-height: 13px;
  padding-top: 10px;
}
</style>
